import { Inject, Injectable } from '@angular/core';
import { IAppConfig } from '@interfaces/app-config/app-config.interface';
import { ITrackDealSnapshotData } from '@interfaces/analytics/facebook-track-deal.interface';
import { generateUUID } from '@helpers/uuid/uuid.helper';
import { APP_CONFIG } from '@tokens/app-config/app-config.token';

declare let fbq;

@Injectable({
  providedIn: 'root',
})
export class FacebookAnalyticsService {
  constructor(@Inject(APP_CONFIG) private config: IAppConfig) {
    fbq('init', this.config.facebookAnalyticsId);
  }

  public pageView(): void {
    fbq('track', 'PageView', {}, { eventID: generateUUID() });
  }

  public saveDeal(device: string): void {
    fbq('trackCustom', 'SaveDeal', { device }, { eventID: generateUUID() });
  }

  public trackPrice(device: string): void {
    fbq('trackCustom', 'TrackPrices', { device }, { eventID: generateUUID() });
  }

  public dealLink(vendorName: string, deviceName: string): void {
    fbq('trackCustom', 'DealLink', { vendorDevice: `${vendorName}|${deviceName}` }, { eventID: generateUUID() });
  }

  public createAccount(): void {
    fbq('trackCustom', 'CreateAccount', {}, { eventID: generateUUID() });
  }

  public viewFindPlanPage(): void {
    fbq('trackCustom', 'PlanConversion', { action: 'plan conversion' }, { eventID: generateUUID() });
  }

  public trackDealSnapshotData(eventData: ITrackDealSnapshotData): void {
    fbq('track', 'ViewContent', eventData, { eventID: generateUUID() });
  }

  public planLoad(): void {
    fbq('trackCustom', 'PlanLoad', { action: 'plan load' }, { eventID: generateUUID() });
  }

  public planSelect(): void {
    fbq('trackCustom', 'PlanSelect', { action: 'plan select' }, { eventID: generateUUID() });
  }

  public phoneLoad(): void {
    fbq('trackCustom', 'PhoneLoad', { action: 'phone load' }, { eventID: generateUUID() });
  }

  public phoneSelect(): void {
    fbq('trackCustom', 'PhoneSelect', { action: 'phone select' }, { eventID: generateUUID() });
  }
}
